<script setup>
/**
 * FormControlModulestructurePassword
 * Composition-based wrapper around the standard checkbox form control.
 * Evaluates field type configurations on mount, instantly hiding itself
 * from the layout if the target entity property type is not explicitly 'text'.
 */
import { onMounted } from 'vue';
import FormControlTypeCheckbox from '@/common/form-control-type/FormControlTypeCheckbox.vue';

const props = defineProps({
    // Standard Orchestrator Props
    formId: {
        type: String,
        required: true
    },
    field: {
        type: Object,
        required: true
    },
    currentData: {
        type: Object,
        required: true
    },
    value: {
        type: [String, Number, Array],
        default: null
    }
});

// --- Lifecycle ---

onMounted(() => {
    /**
     * Contextual visibility guard: If this structure element's type
     * is not 'text', drop visibility from the orchestration form layer.
     */
    if (props.currentData?.type !== 'text' && props.field) {
        props.field.hidden = true;
    }
});
</script>

<template>
    <FormControlTypeCheckbox v-bind="$props" v-if="!field.hidden"/>
</template>

<style scoped>
/* Presentation properties are inherited directly from FormControlTypeCheckbox */
</style>